import { Box } from '@chakra-ui/react'
import { apps } from 'config/apps'
import { BotulismPages } from 'config/apps/Botulism/BotulismPages'
import { createElement } from 'react'

const ClinicalTrialsDashboard = () => {
  const page = BotulismPages['ClinicalTrials']
  return (
    <Box>
      {createElement(page.component, {
        app: apps['botulism'],
        views: page.views,
        model: page.model,
        page: page,
      })}
    </Box>
  )
}

export default ClinicalTrialsDashboard
